export function createLink(selector, options) {
  try {
    window.Strava.BranchIO.createLink(options).done((link) => {
      document.querySelector(selector).setAttribute('href', link);
    });
  } catch (err) {
    console.warn(err); // eslint-disable-line
  }
}

export default {
  createLink
};
